import React from 'react';
import { Loader2, TruckIcon, CheckCircle } from 'lucide-react';

function StatusFooter({ deliveryPoints }) {
  function getServiceStatus() {
    if (!deliveryPoints || deliveryPoints.length === 0) {
      return {
        type: 'idle',
        message: 'Sin entregas activas',
        icon: 'idle',
      };
    }

    const statuses = deliveryPoints.map(dp => dp.status);
    const allFinished = statuses.every(
      status => status === 'entregado' || status === 'cancelado' || status === 'rechazado'
    );

    if (allFinished) {
      return {
        type: 'finished',
        message: 'Servicio finalizado - Todas las entregas completadas',
        icon: 'finished',
      };
    }

    // Check for deliveries en_camino with arrival_time
    const enCaminoDeliveries = deliveryPoints.filter(
      dp => dp.status === 'encamino' && dp.arrival_time
    );

    if (enCaminoDeliveries.length > 0) {
      // Find the closest one
      const now = new Date();
      const closest = enCaminoDeliveries.reduce((prev, current) => {
        const prevTime = new Date(prev.arrival_time);
        const currentTime = new Date(current.arrival_time);
        const prevDiff = Math.abs(prevTime - now);
        const currentDiff = Math.abs(currentTime - now);
        return currentDiff < prevDiff ? current : prev;
      });

      const arrivalTime = new Date(closest.arrival_time);
      const timeString = arrivalTime.toLocaleTimeString('es-PE', {
        hour: '2-digit',
        minute: '2-digit',
      });

      return {
        type: 'next-delivery',
        message: `Próxima entrega: ${closest.recipient_name} - ${timeString}`,
        icon: 'next',
      };
    }

    // Default: processing
    return {
      type: 'processing',
      message: 'Procesando entregas...',
      icon: 'processing',
    };
  }

  const status = getServiceStatus();

  function getStatusStyles() {
    switch (status.type) {
      case 'finished':
        return 'bg-[#67A43C] text-white';
      case 'next-delivery':
        return 'bg-[#E6B43C] text-white';
      case 'processing':
        return 'bg-[#B1336E] text-white';
      default:
        return 'bg-slate-200 text-slate-700';
    }
  }

  function renderIcon() {
    switch (status.icon) {
      case 'finished':
        return <CheckCircle className="w-5 h-5" />;
      case 'next':
        return <TruckIcon className="w-5 h-5" />;
      case 'processing':
        return <Loader2 className="w-5 h-5 animate-spin" />;
      default:
        return null;
    }
  }

  return (
    <div className={`flex-shrink-0 ${getStatusStyles()} shadow-lg z-30`}>
      <div className="px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-3">
          {renderIcon()}
          <p className="text-sm sm:text-base font-bold font-montserrat">
            {status.message}
          </p>
        </div>
      </div>
    </div>
  );
}

export default StatusFooter;